/* eslint-disable class-methods-use-this */
// @ts-ignore
import mixpanel from 'mixpanel-browser';
import { ActivityTracker } from '@/services/activityTracker/adapters/contracts/activity-tracker';
import { isDev } from '@/ui/helpers/systemHelper';

export class MixpanelTracker implements ActivityTracker {
  protected apiKey: string;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
    // if you need to have a second instance of mixpanel you can call `init` again
    // https://developer.mixpanel.com/docs/javascript-full-api-reference#mixpanelinit
    mixpanel.init(apiKey, { debug: isDev });
  }

  identifyUser(): void {
    mixpanel.identify();
  }

  setUser(id: string | null): void {
    mixpanel.identify(id as unknown as (string | undefined));
  }

  trackEvent(event: string, properties: Record<string, unknown>): void {
    mixpanel.track(event, properties);
  }

  unsetUser(): void {
    mixpanel.reset();
  }
}
